<script>
	import { page } from '$app/stores';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Lead from '$lib/PageSections/Forms/Lead/Lead.svelte';
	import GuaranteedForALifetime from '$lib/PageSections/GuaranteedForALifetime/GuaranteedForALifetime.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import banner from './images/01-top-image-IRA-LP.jpg?quality=95';
	import windowframe from './images/02-image-IRA-LP.png';
	import noiseGuy from './images/04-image-IRA-LP_optimized-cropped.svg';
	import changeJar from './images/05-image-IRA-LP.png?w=300;400;600&quality=99';
	import manufacturerCert from './Indow_IRA_Manufacturer_Certification.pdf';
</script>

<Section backgroundImage={banner} backgroundColor="blue">
	<h1>
		{$page?.data?.h1}
	</h1>
</Section>
<Section class="pb-0 pt-0">
	<div class="full-width w-full bg-indow-green">
		<p
			class="text-balance py-6 text-center text-xl font-semibold text-indow-white md:text-2xl"
		>
			Get a head start and lock in your tax credits for the 2025 tax year!
		</p>
	</div>
</Section>
<Section backgroundColor="white">
	<div
		class="grid grid-cols-1 place-items-center gap-x-16 gap-y-8 md:grid-cols-2"
	>
		<Image
			src={windowframe}
			alt="illustrated window frame with Indow insert installed"
			class="max-w-sm"
		/>
		<div class="flex flex-col">
			<h2 class="text-left text-indow-blue">HUGE SAVINGS ON INSERTS</h2>

			<p class="text-left">
				You can save 30% on the cost of energy-saving Indow window inserts with
				tax credits from the Inflation Reduction Act. With these tax credits,
				you can lower your tax bill by up to $1,200 by purchasing approved
				energy efficient window inserts - that's over $100 in savings on a
				standard size Indow window insert!
			</p>

			<p class="text-left">
				The best part? Indow's insulating window inserts qualify for this tax
				savings of up to $1,200/year on energy efficient home improvements.
			</p>
		</div>
	</div>
</Section>
<Section backgroundColor="grey-light">
	<div class="grid grid-cols-1 gap-x-16 gap-y-8 md:grid-cols-2">
		<div class="flex flex-col">
			<h2 class="text-left text-indow-blue md:text-right">
				POWER UP YOUR WINDOWS
			</h2>
			<p class="text-left md:text-right">
				Improve the energy efficiency of your home, eliminate cold drafts in the
				winter, and keep your home cooler in the summer with our custom-made
				window inserts.
			</p>
			<p class="text-left md:text-right">
				Indow customers save an average of 20% on heating & cooling bills and
				installation is a cinch - your inserts will slide right into place and
				can be easily removed when needed.
			</p>
			<p class="text-left md:text-right">
				<a
					href="/solutions/insulating-drafty-windows"
					class="text-indow-blue underline">Learn more</a
				> about how Indow inserts can improve your home's energy efficiency or talk
				to one of our expert Fit Specialists today!
			</p>
		</div>

		<Lead buttonText="Contact Me" />
	</div>
</Section>

<GuaranteedForALifetime />

<Section backgroundColor="white">
	<div class="grid gap-x-16 gap-y-8 md:grid-cols-2 md:place-items-center">
		<div class="grid w-full justify-items-center md:items-start">
			<Image
				src={noiseGuy}
				alt="illustrated person suffering with noise"
				loading="lazy"
				class="w-full max-w-sm"
			/>
		</div>
		<div>
			<h2 class="text-left !text-indow-blue">KEEP NOISE OUT, LET LIGHT IN</h2>

			<p class="text-left">
				Bothered by noisy neighbors or street noise? In addition to lowering
				energy bills and increasing comfort, Indow window inserts reduces
				outside noise by at least 50%.
			</p>
			<p class="text-left">
				But, if noise is a major problem in your home, you can upgrade your
				purchase to our <a href="/solutions/window-noise-reduction"
					>Acoustic Grade window inserts</a
				> and enjoy up to 70% noise reduction.
			</p>
			<p class="text-left">
				You'll sleep better, feel better, enjoy your space more - and because
				our Acoustic Grade inserts are just as effective at improving energy
				efficiency - you can still save big with the IRA tax credits.
			</p>
		</div>
	</div>
</Section>

<Section backgroundColor="blue" class="pb-0">
	<div class="grid gap-x-16 md:grid-cols-2 md:place-items-center">
		<div class="pb-8">
			<h2 class="text-left text-white md:text-right">
				ABOUT THE ENERGY EFFICIENT HOME IMPROVEMENT CREDIT
			</h2>
			<p class="text-left md:text-right">
				Indow is a <a href={manufacturerCert} class="text-white underline"
					>certified manufacturer</a
				>
				of “eligible building envelope components” (window inserts) that may qualify
				for the
				<a
					href="https://www.irs.gov/credits-deductions/frequently-asked-questions-about-energy-efficient-home-improvements-and-residential-clean-energy-property-credits-energy-efficient-home-improvement-credit-qualifying-expenditures-and-credit-amount#:~:text=Building%20envelope%20components"
					target="_blank"
					rel="external"
					class="text-white underline">Inflation Reduction Act</a
				> tax credit pursuant Section 25C of IRS Notice 2022-48.
			</p>
			<p class="text-left md:text-right">
				To qualify for this credit, your window inserts must be installed in a
				dwelling unit located in the United States and the order must be shipped
				in the tax year you are claiming the credit for. $1,200 is the maximum
				allowable credit for all qualified energy efficiency improvements in a
				single tax year.
			</p>
			<p class="text-left md:text-right">
				Due to the complexity and uniqueness of tax law, we recommend consulting
				a tax advisor if you are uncertain about your eligibility for this
				credit.
			</p>
		</div>
		<div class="self-end">
			<Image src={changeJar} loading="lazy" class="max-md:max-w-80" />
		</div>
	</div>
</Section>

<Reviews />
